// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Offers Drawer ──────────────────────────────────────── */
.ofd-shell {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 201;
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  border-radius: 0;
  border-left: 1px solid #e2e8f0; /* border-slate-200 */
  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ofdDrawerIn 220ms ease-out;
  outline: none;
}

@media (min-width: 768px) {
  .ofd-shell {
    width: 820px; /* md:w-[820px] */
  }
}

/* Header */
.ofd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px; /* px-5 py-4 */
  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));
  flex-shrink: 0;
}

.ofd-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.ofd-title {
  margin: 0;
  font-size: 20px !important; /* text-xl */
  font-weight: 700;
  color: #0f172a; /* text-slate-900 */
  letter-spacing: -0.025em; /* tracking-tight */
  line-height: 1.2;
}

.ofd-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.ofd-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 9999px; /* rounded-full */
  padding: 4px 8px; /* keep existing button height */
  transition: all 0.15s;
}

.ofd-close-icon {
  width: 16px; /* h-4 w-4 */
  height: 16px;
  color: #64748b; /* text-slate-500 */
}

.ofd-close:hover {
  background: #f1f5f9;
}

/* Body */
.ofd-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px; /* px-5 py-5 */
}

.ofd-cards-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px; /* space-y-3 */
}

/* Loader / Empty states */
.ofd-loader,
.ofd-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ofd-empty p {
  color: #6b7280;
  font-size: 14px !important;
}

/* Slide-in animation */
@keyframes ofdDrawerIn {
  from {
    transform: translateX(100%);
    opacity: 0.98;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Thin Scrollbar styling */
.ofd-body::-webkit-scrollbar {
  width: 6px;
}

.ofd-body::-webkit-scrollbar-track {
  background: transparent;
}

.ofd-body::-webkit-scrollbar-thumb {
  background: #cbd5e1; /* slate-300 */
  border-radius: 9999px;
}

.ofd-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8; /* slate-400 */
}

.ofd-body {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/offerListing/index.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B,EAAE,qBAAqB;EACrD,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE;IACE,YAAY,EAAE,iBAAiB;EACjC;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB,EAAE,cAAc;EAClC,gCAAgC,EAAE,qBAAqB;EACvD,yFAAyF;EACzF,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,SAAS;EACT,0BAA0B,EAAE,YAAY;EACxC,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,wBAAwB,EAAE,mBAAmB;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB,EAAE,iBAAiB;EACxC,gBAAgB,EAAE,gCAAgC;EAClD,qBAAqB;AACvB;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa,EAAE,cAAc;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,cAAc;AAC3B;;AAEA,0BAA0B;AAC1B;;EAEE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE;IACE,2BAA2B;IAC3B,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB,EAAE,cAAc;EACnC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB,EAAE,cAAc;AACrC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC","sourcesContent":["/* ── Offers Drawer ──────────────────────────────────────── */\n.ofd-shell {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 201;\n  width: 100vw;\n  height: 100vh;\n  background: #ffffff;\n  border-radius: 0;\n  border-left: 1px solid #e2e8f0; /* border-slate-200 */\n  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: ofdDrawerIn 220ms ease-out;\n  outline: none;\n}\n\n@media (min-width: 768px) {\n  .ofd-shell {\n    width: 820px; /* md:w-[820px] */\n  }\n}\n\n/* Header */\n.ofd-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px; /* px-5 py-4 */\n  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */\n  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));\n  flex-shrink: 0;\n}\n\n.ofd-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.ofd-title {\n  margin: 0;\n  font-size: 20px !important; /* text-xl */\n  font-weight: 700;\n  color: #0f172a; /* text-slate-900 */\n  letter-spacing: -0.025em; /* tracking-tight */\n  line-height: 1.2;\n}\n\n.ofd-header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.ofd-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 9999px; /* rounded-full */\n  padding: 4px 8px; /* keep existing button height */\n  transition: all 0.15s;\n}\n\n.ofd-close-icon {\n  width: 16px; /* h-4 w-4 */\n  height: 16px;\n  color: #64748b; /* text-slate-500 */\n}\n\n.ofd-close:hover {\n  background: #f1f5f9;\n}\n\n/* Body */\n.ofd-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px; /* px-5 py-5 */\n}\n\n.ofd-cards-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px; /* space-y-3 */\n}\n\n/* Loader / Empty states */\n.ofd-loader,\n.ofd-empty {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ofd-empty p {\n  color: #6b7280;\n  font-size: 14px !important;\n}\n\n/* Slide-in animation */\n@keyframes ofdDrawerIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0.98;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Thin Scrollbar styling */\n.ofd-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ofd-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.ofd-body::-webkit-scrollbar-thumb {\n  background: #cbd5e1; /* slate-300 */\n  border-radius: 9999px;\n}\n\n.ofd-body::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8; /* slate-400 */\n}\n\n.ofd-body {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
